<div
    [agprLoading]="loading"
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
>
<ng-template #tabHeader>
    @if (!hideBusinessCard) {
        <agpr-entity-business-card
            [id]="id + '_rhpContextsBusinessCard'"
            [isRHP]="true"
            [canOpenFullProfile]="false"
            [entity]="entity"
            [contactPrivateData]="contactPrivateData"
            [outletPrivateData]="outletPrivateData"
            (selectedEmploymentChanged)="selectedEmploymentChanged"
            [isCondensedMode]="true"
        >
        </agpr-entity-business-card>
    }

    <div class="toolbar">
        <!-- top row -->
        <div
            class="toolbar-wrapper"
            [@toolbarCollapsed]="toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled"
            (@toolbarCollapsed.start)="onAnimationStart($event)"
            (@toolbarCollapsed.done)="onAnimationDone($event)"
        >
            <div
                class="toolbar-filter"
                [ngClass]="{'toolbar-filter--chips': chipsVisible}"
            >
                <agpr-filter-dropdown
                    id="resultsFilters"
                    [showQuickFilter]="true"
                    quickFilterPlaceholder="Discover.entityProfile.recentCoverage.filterPlaceholder"
                    [ariaLabel]="'Discover.interactionView.filterLabel'"
                    ariaDescribedBy="interactionView.filterChips"
                ></agpr-filter-dropdown>
                <agpr-sort-order
                    [id]="'interactionView-sortOrder'"
                    [isDisabled]="!total"
                    tooltip="Discover.targeting.tooltips.sort"
                    optionKey="enumValue"
                    optionLabel="displayString"
                ></agpr-sort-order>
            </div>
            @if (chipsVisible) {
                <agpr-filter-chips
                    class="toolbar-chips"
                    [id]="'interactionView.filterChips'"
                ></agpr-filter-chips>
            }
        </div>
        <!-- bottom row -->
        <div
            class="toolbar-paginator"
            [style.width]="toolbarStateService.toolbarCollapsed ? toolbarStateService.toolbarWidth + 'px' : '100%'"
        >
            <span class="toolbar-paginator-count">
                {{ total }}
            </span>
            <span>
                {{'Discover.targeting.rhp.tabs.interactionView' | localize }}
            </span>
            <agpr-minimal-paginator
                [isDisabled]="!total"
            ></agpr-minimal-paginator>
        </div>
    </div>
    </ng-template>

    <agpr-message
        *ngIf="!total"
        [severity]="messageSeverityEnum.noContent"
        [useWhiteBg]="true"
    >
        {{ 'Discover.interactionView.noContent' | localize }}
    </agpr-message>

    <ul
        id="interactionsList"
        class="agpr-interactionview-list"
        [attr.aria-label]="'Discover.interactionView.ariaLabel.interactionList' | localize"
        agprListKeyboardNavigation
        [focusOnChild]="true"
        [list]="interactions"
        focusableElementCustomSelector=".agpr-interactionCard-wrapper"
    >
        <li *ngFor="let interaction of interactions; let i = index">
            <agpr-interaction-card
                [interaction]="interaction"
                (edit)="openAddInteractionDialog($event)"
                (delete)="interactionViewService.deleteInteraction($event)"
                (viewConversation)="viewConversation(interaction)"
            ></agpr-interaction-card>
        </li>
    </ul>

    <ng-template #tabFooter>
        <agpr-action-bar
            *ngIf="selected"
            [headingContext]="'Discover.targeting.rhp.tabs.interactionView' | localize"
            headingLevel="4"
        >
            <ng-template #right>
                <agpr-button
                    id="interactionView.addInteractionButton"
                    [style]="buttonTypes.tertiary"
                    label="Discover.interactionView.add"
                    (click)="openAddInteractionDialog()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>
</div>
